import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { ValmetGrey10, ValmetGrey15 } from 'theme';

interface Props {
  disabled: boolean;
  text: string;
  handleClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    submitButton: {
      border: `1px solid ${ValmetGrey10}`,
      backgroundColor: ValmetGrey15,
      borderRadius: "3px",
      padding: "10px",
    },
    buttonActive: {
      cursor: "pointer",
    },
    buttonInProgress: {
      cursor: "progress",
    },
  }),
);

const CustomButton: React.FC<Props> = ({ disabled, text, handleClick }) => {
  const localClasses = localStyles();

  return (
    <button
      type="button"
      onClick={(event) => handleClick(event)}
      disabled={disabled}
      className={
        disabled
          ? `${localClasses.submitButton} ${localClasses.buttonInProgress}`
          : `${localClasses.submitButton} ${localClasses.buttonActive}`
      }
    >
      {text}
    </button>
  )
}

export default CustomButton;